import React from "react";
import PublicShell from "../components/PublicShell";
import { ScrollText } from "lucide-react";

const paragraphs = [
  "تسعى منصة إمداد دائماً للتحقق من التجار والمنتجات المعروضة على المنصة، ولكنها غير مسؤولة عن أي عملية احتيال أو غش أو نصب يحدث بين التجار. المنصة هي وسيط فقط وليست طرفاً في أي صفقة.",
  "للمنصة الحق الكامل في حذف أي تاجر أو أي منتج من المنصة دون إشعار مسبق ودون الحاجة إلى ذكر أي مبرر.",
  "تعمل منصة إمداد وفق أحكام الشريعة الإسلامية. أي منتج أو نشاط أو تعامل مخالف للشريعة الإسلامية يعتبر مرفوضاً تماماً ولن يتم قبوله على المنصة.",
  "كل تاجر مسجل على منصة إمداد يمثل نفسه بنسبة 100% ولا يمثل المنصة بأي شكل من الأشكال. المنصة لا تتبنى أي أفكار أو آراء أو توجهات سياسية أو عدائية تجاه أي فرد أو جهة على الإطلاق.",
  "باستخدامك لهذه المنصة، أنت توافق على جميع الشروط والأحكام المذكورة أعلاه.",
];

const Terms = () => (
  <PublicShell>
    <section className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-testid="terms-page">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[#7AB2B2] text-xs font-bold text-[#09637E] mb-5">
        <ScrollText size={14} /> السياسات
      </div>
      <h1 className="text-4xl md:text-5xl font-extrabold text-[#333333] mb-6">الشروط والأحكام</h1>
      <div className="bg-white border border-[#7AB2B2] rounded-2xl p-6 md:p-8 space-y-5 text-[#333333] leading-loose">
        {paragraphs.map((p, i) => (
          <p key={p.slice(0, 30)} className="text-base md:text-lg">
            <span className="inline-block w-7 h-7 rounded-full bg-[#09637E] text-white text-sm font-extrabold ml-3 text-center leading-7 align-middle">{i + 1}</span>
            {p}
          </p>
        ))}
      </div>
      <p className="text-center text-[#666666] text-sm mt-6">آخر تحديث: فبراير 2026</p>
    </section>
  </PublicShell>
);

export default Terms;
